exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list_item>div>span[data-v-46f7cef3],.list_item>p>span[data-v-46f7cef3]{margin-left:20px}.list_item .el-input[data-v-46f7cef3],.list_item .el-select[data-v-46f7cef3]{width:200px}\n", ""]);

// exports
